<template>
<div>
    <v-slide-y-reverse-transition>
        <v-card outlined class="bg_none" flat v-show="transition" light>
            <v-card-title class="text-primary text-center text-h5 font-weight-black">INGRESAR</v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pt-0 mt-5">
                <v-form ref="form" v-model="formValid">
                    <v-text-field v-model="form.user_name" :rules="formRules.user" outlined dense label="Usuario" autocorrect="off" autocapitalize="off"></v-text-field>
                    <v-text-field outlined dense v-model="form.user_password" :rules="formRules.required" label="Contraseña" type="password"></v-text-field>
                    <v-btn color="primary" large depressed block @click="login" :loading="loading" :disabled="loading || !formValid">ENTRAR</v-btn>
                </v-form>
            </v-card-text>
        </v-card>
    </v-slide-y-reverse-transition>
</div>
</template>

<script>
import {
    formValidation
} from "@/libs/formValidation";
import ApiService from '../../libs/apiService';
export default {
    name: "Login",
    mixins: [formValidation],
    data() {
        return {
            form: {
                user_name: null,
                user_password: null
            },
            loading: false,
            transition: false,
            event: null
        };
    },
    methods: {
        async login() {
            const apiService = new ApiService();
            this.loading = true;
            await apiService.post('/login', this.form).then(res => {
                this.loading = false;
                this.$store.dispatch('setToken', res.token);
                this.$store.dispatch('setUser', this.form.user_name);
                if (res.token) {
                    this.$router.push('/dashboard').catch(() => {});
                }
            }).catch(err => {
                this.loading = false;
                let msg = '';
                switch (err.status) {
                    case 401: {
                        msg = 'Nombre de usuario o contraseña incorrectos';
                        break;
                    }
                    case 403: {
                        msg = 'Se ha bloqueado su cuenta, comuniquese con el administrador: admin@coink.com';
                        break;
                    }
                    case 500: {

                        msg = 'Vuelva a intentar más tarde';
                        break;
                    }
                    default: {
                        msg = 'Vuelva a intentar más tarde';
                        break;
                    }
                }
                this.$store.dispatch("setAlert", {
                    show: true,
                    msg: msg,
                    color: 'error'
                });
            });
        }
    },
    created() {
        setTimeout(() => {
            this.transition = true
        }, 1000);
    }
};
</script>

<style lang="scss" scoped>
@import "./Login.scss";
</style>
